import type { KrHoldingOwnership } from '../../services/marketWatchlistApi';

export default function KrHoldingsOwnership({ items }: { items: KrHoldingOwnership[] }) {
  if (!items.length) return <div className="system-state">Toss KR 보유종목 데이터 없음</div>;
  return (
    <div className="kr-holdings-ownership">
      <h3>Toss KR 보유종목 자동매매 대상 여부</h3>
      <ul>
        {items.map((item) => (
          <li key={item.symbol}>
            <strong>{item.name || item.symbol}</strong>
            <span>{item.name ? item.symbol : ''}</span>
            <span>{ownershipLabel(item.ownership_state)}</span>
            <span>{managedLabel(item.ownership_state)}</span>
            <span>{pnlLabel(item)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function ownershipLabel(state: string) {
  return {
    external_observed: '관찰 전용',
    managed_existing: '기존 보유 편입',
    strategy_managed: '전략 생성',
    excluded: '자동매매 제외',
  }[state] || state;
}

function managedLabel(state: string) {
  return ['managed_existing', 'strategy_managed'].includes(state)
    ? '자동매매 대상'
    : '자동매매 비대상';
}

function pnlLabel(item: KrHoldingOwnership) {
  return `수량 ${item.quantity} · 평가 ${krw(item.market_value)} · 손익 ${krw(item.unrealized_pl)}`;
}

function krw(value?: number | null) {
  if (value === undefined || value === null) return '데이터 없음';
  return `${Math.round(value).toLocaleString('ko-KR')}원`;
}
